import { useQuery } from "@tanstack/react-query";
import client, { unwrap } from "@/api/client";

// Loads every visible catalogue and all of their products. There is no
// cross-catalogue products endpoint yet, so this fetches one list per catalogue;
// the Products and Catalogues pages share the cached result.
export default function useCatalogueProducts() {
  const cataloguesQuery = useQuery({ queryKey: ["catalogues"], queryFn: () => client.get("/catalogues").then(unwrap) });
  const catalogues = cataloguesQuery.data || [];

  const productsQuery = useQuery({
    queryKey: ["all-products", catalogues.map((c) => c._id).join(",")],
    queryFn: async () => {
      const lists = await Promise.all(
        catalogues.map((c) => client.get(`/catalogues/${c._id}/products`).then(unwrap).catch(() => [])),
      );
      return lists.flat();
    },
    enabled: catalogues.length > 0,
  });

  return {
    catalogues,
    products: productsQuery.data || [],
    cataloguesLoading: cataloguesQuery.isLoading,
    productsLoading: productsQuery.isLoading && catalogues.length > 0,
  };
}
